export default __webpack_public_path__ + "img/Poppins-Black_3ea07c3.eot";